<template>
  <div class="pagination" v-if="total>0">
    <span class="titel" v-if="total>10000">共10000+条记录 </span>
    <span class="titel" v-else>共{{ total }}条记录</span>
    <span class="titel"> 共 {{ Math.ceil((total>10000 ? 10000 : total) / limit) }} 页 </span>
    <span class="titel">每页{{ limit }}条</span>
    <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="page" :pager-count="5"
                   :page-size="limit" background :hide-on-single-page="true" layout="prev, pager, next" :total="total>10000 ? 10000 : total"
                   prev-text="上一页" next-text="下一页">
    </el-pagination>
    <div v-show="totalPage > 1">
      <span style="font-size:14px;color:#333">转向第</span>
      <el-input v-model="navPage" class="pageInput" type="tel"></el-input>
    </div>
    <el-button class="btn" @click="sure" v-show="totalPage > 1">确定</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      state: {},
      navPage: 1,
    };
  },
  computed: {
    totalPage() {
      if (this.allPage == 0) {
        return Math.ceil(this.total / this.limit)
      } else {
        return this.allPage
      }
    }
  },
  props: {
    type: String,
    //总条数
    total: {
      type: [String, Number],
      default: 0,
    },
    //总页数
    allPage: {
      type: [String, Number],
      default: 0,
    },
    //每页多少条
    limit: {
      type: [String, Number],
      default: 10,
    },
    page:{
      type: [String, Number],
      default: 1,
    },
  },
  methods: {
    sizeChange(pageSize) {
    },
    // 切换页数
    currentChange(currentPage) {
      this.currentPage = parseInt(currentPage)
      this.$emit('currentPage', parseInt(currentPage));
    },
    sure() {
      let patt = /^\+?[1-9][0-9]*$/;
      let flag = patt.test(this.navPage)
      if (!flag) {
        this.$message.error('请输入正确的页码')
        return
      }
      if (parseInt(this.navPage) > this.totalPage) {
        this.currentPage = this.totalPage
        this.navPage = this.totalPage
        this.page=parseInt(this.navPage);
      } else {
        this.currentPage = parseInt(this.navPage);
        this.page=parseInt(this.navPage);
      }
      this.$emit('currentPage', parseInt(this.navPage));
    }
  },
  mounted() {

  },
};
</script>

<style scoped lang="scss">
.pagination {
  padding-bottom: 10px;
  display: flex;
  justify-content: start;
  align-items: center;
}

.titel {
  font-size: 14px;
  font-family: 'SourceHanSansCN';
  font-weight: 100;
  color: #333333;
  margin-right: 10px;
}

.btn {
  width: 50px;
  height: 40px;
  line-height: 40px;
  background: transparent;
  padding: 0px;
  font-size: 14px;
  font-family: 'SourceHanSansCN';
  font-weight: 100;
  color: #333333;
  margin-left: 0px;
}

.pageInput {
  width: 60px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 0 6px;
}
</style>
<style scoped>
.pagination >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: transparent;
  color: #FE273B;
  border: 1px solid #FE273B;
}

.pagination >>> .el-pager li {
  width: 40px;
  height: 40px;
  margin: 0 2px;
  line-height: 40px;
  border: 1px solid #ddd;
}
.pagination >>> .el-pagination {
  padding: 2px 0px;
}

.pagination >>> .el-pagination .btn-prev, .pagination >>> .el-pagination .btn-next {
  height: 40px;
  border: 1px solid #ddd;
  padding: 0 10px;
}

.pagination >>> .el-pagination__jump {
  height: 40px;
  line-height: 40px;
}

.pagination >>> .el-pagination__editor.el-input .el-input__inner {
  height: 40px;
  margin: 0 4px;
}

.pageInput >>> .el-input__inner {
  text-align: center;
}
</style>